import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  createCompanyCertificate,
  updateCompanyCertificate,
  deleteCompanyCertificate,
} from "../../../../../redux/slice/companySlice";
import { PlusIcon, EditIcon, Delete02Icon } from "../../../../../assets/icons";
import CompanyCertificateModal from "../../../../../components/modals/company/CompanyCertificateModal";
import DeletePopup from "../../../../../components/delete-popup";
import { formatMomentDate } from "../../../../../utils/dateHelper";
import { usePermission } from "../../../../../hooks/usePermission";
import { useToast } from "../../../../../context/TostContext";
import { UserInital } from "../../../../../utils/otherHelopers";

const MODULE = "company_management";

const Certifications = () => {
  const {id} = useParams();
  const dispatch = useDispatch();
  const { hasPermission } = usePermission();
  const toast=useToast();
  const { companyDetail, certificateActionLoading } = useSelector((state) => state.company);

  const [certificateModal, setCertificateModal] = useState({ show: false, certificate: null });
  const [deleteCertificateModal, setDeleteCertificateModal] = useState({ show: false, id: null });

  const handleCertificateSubmit = async (data) => {
    try {
      let res;
      if (certificateModal.certificate) {
        res = await dispatch(updateCompanyCertificate({ companyId: id, id: certificateModal.certificate.id, data })).unwrap();
      } else {
        res = await dispatch(createCompanyCertificate({ companyId: id, data })).unwrap();
      }
      if (res) {
        toast.success(`Certificate ${certificateModal.certificate ? "updated" : "added"} successfully`);
        setCertificateModal({ show: false, certificate: null });
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
    }
  };

  const handleDeleteCertificate = async () => {
    try {
      await dispatch(deleteCompanyCertificate({ companyId: id, id: deleteCertificateModal.id })).unwrap();
      toast.success("Certificate deleted successfully");
      setDeleteCertificateModal({ show: false, id: null });
    } catch (error) {
      toast.error(error?.message || "Failed to delete certificate");
    }
  };

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h5 className="fw-bold mb-0" style={{ fontSize: "16px", color: "#444050" }}>
          Certifications
        </h5>
        {hasPermission(MODULE, "update") && (
          <button
            className="btn btn-primary btn-sm d-flex align-items-center gap-1"
            onClick={() => setCertificateModal({ show: true, certificate: null })}
          >
            <PlusIcon size={14} />
            Add Certificate
          </button>
        )}
      </div>

      {companyDetail?.certificates?.length > 0 ? (
        <div className="row g-3">
          {companyDetail.certificates.map((item, index) => (
            <div key={index} className="col-12 col-md-6">
              <div className="border rounded p-3 position-relative bg-light-subtle h-100">
                <div className="position-absolute top-0 end-0 p-2 d-flex gap-2">
                  {hasPermission(MODULE, "update") && (
                    <button
                      className="post-action-btn edit-btn border rounded p-1 bg-white"
                      onClick={() => setCertificateModal({ show: true, certificate: item })}
                    >
                      <EditIcon width={12} height={12} color="#007bff" />
                    </button>
                  )}
                  {hasPermission(MODULE, "delete") && (
                    <button
                      className="post-action-btn delete-btn border rounded p-1 bg-white"
                      onClick={() => setDeleteCertificateModal({ show: true, id: item.id })}
                    >
                      <Delete02Icon width={12} height={12} color="#FF0000" />
                    </button>
                  )}
                </div>

                <div className="d-flex gap-3 align-items-start w-100">
                  <UserInital width={50} image={item?.file?.file_url} name={item?.title} />
                  
                  <div className="flex-grow-1 overflow-hidden" style={{ paddingRight: "75px" }}>
                    <p className="sub-head text-break mb-0 fw-semibold">
                      {item?.title || "-"}
                    </p>
                    <p className="sub-text fw-medium text-dark mb-0 mt-1 text-break small">
                      {item?.provider || "-"}
                    </p>
                    {item.issued_date && (
                      <p className="sub-text mb-0 text-muted mt-1 small">
                        Issued {formatMomentDate(item.issued_date, "MMMM YYYY")}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-muted text-center py-4 small">No certificates available.</p>
      )}

      <CompanyCertificateModal
        isOpen={certificateModal.show}
        onClose={() => setCertificateModal({ show: false, certificate: null })}
        onSubmit={handleCertificateSubmit}
        certificate={certificateModal.certificate}
        isLoading={certificateActionLoading}
        title={certificateModal.certificate ? "Edit Company Certificate" : "Add Company Certificate"}
        size="lg"
      />

      <DeletePopup
        show={deleteCertificateModal.show}
        onHide={() => setDeleteCertificateModal({ show: false, id: null })}
        onConfirm={handleDeleteCertificate}
        disabled={certificateActionLoading}
        title="Delete Certificate"
        content="Are you sure you want to delete this certificate? This action cannot be undone."
        saveTitle="Delete"
      />
    </>
  );
};

export default Certifications;
